import React from 'react';
import { TableRow } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { CREDIT_PRODUCT_TYPE_OPTIONS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import type { ICreditOperationRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/creditOperations/types.ts';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import {
  filterBankOptions,
  normalizeDecimalValue,
  normalizePercentageValue,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

export const CreditOperationRow: React.FC<ICreditOperationRowProps> = ({
  index,
  canRemove,
  disabled,
  lenderOptions,
  currencyOptions,
  isBanksLoading,
  isCurrenciesLoading,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`creditOperations.${index}.lenderName`}
        label="Найменування кредитора"
        options={lenderOptions}
        loading={isBanksLoading}
        filterOptions={filterBankOptions}
        shouldSaveLabel
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`creditOperations.${index}.productType`}
        label="Тип продукту"
        options={CREDIT_PRODUCT_TYPE_OPTIONS}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormAutocomplete
        name={`creditOperations.${index}.currency`}
        label="Валюта"
        options={currencyOptions}
        loading={isCurrenciesLoading}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`creditOperations.${index}.limit`}
        label="Ліміт"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`creditOperations.${index}.outstandingDebt`}
        label="Заборгованість"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`creditOperations.${index}.interestRate`}
        label="Процентна ставка"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizePercentageValue}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`creditOperations.${index}.issueDate`}
        label="Дата надання"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormDateInput
        name={`creditOperations.${index}.maturityDate`}
        label="Дата погашення"
        disabled={disabled}
        sx={financialConditionTableFieldStyles.dateField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`creditOperations.${index}.overdueDebt`}
        label="Прострочення"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити операцію ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
